import ReactJson from "react-json-view";

import { JsonEditor } from 'json-edit-react'
import { useEffect, useState } from 'react'
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { MdDragIndicator } from "react-icons/md";
import { useQuery } from '@tanstack/react-query';
import { fetchBenefitPlanDetail, submitJobBenefitPlan, submitBenefitPlanAudit, fetchGetApiRequestJobStatus } from "../../../utils/apiUtils";
import { omit, unset } from "lodash";
import { Bounce, toast } from 'react-toastify';
import Modal from "../../modal/Modal";
import { customStringify, delay } from "../../../utils/commonUtils";
import { useNavigate } from "react-router";
import { ACTIONS } from "../../../utils/constants";
import ReactDiffViewer from 'react-diff-viewer';
// handle amend payload form other environment
// if plan doesn't already exist we need to create and amend the plan
const MigrateBenefitPlan = () => {
    const [jsonString, setJsonString] = useState('');
    const [jsonData, setJsonData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    // const [isCreated, setIsCreated] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false)

    const [viewDiff, setViewDiff] = useState(false)
    const navigate = useNavigate()
    useEffect(() => {
        try {
            setErrorMessage(null);
            if (!jsonString) {
                setJsonData(null);
            } else {
                const data = JSON.parse(jsonString);
                setJsonData(data);
            }

        } catch (err) {
            setErrorMessage('Invalid JSON format');
        }
    }, [jsonString])

    const { isFetching, isPending, error, data, refetch } = useQuery({
        queryKey: ['getBenefitPlanDetailsByBenefitPlanHccId', jsonData?.benefitPlan?.benefitPlanHccId],
        queryFn: () => fetchBenefitPlanDetail({ benefitPlanHccId: jsonData?.benefitPlan?.benefitPlanHccId, }),
        enabled: !!jsonData
    })

    const exisitngBenefitPlan = data?.items?.[0];

    let createPayload;

    if (!exisitngBenefitPlan) {
        createPayload = omit({
            ...jsonData,
            maintenanceInfo: {
                "transactionType": "Create",
                "overrideAction": true
            },
            maintenanceReasonCode: {
                codeSetName: 'BenefitPlanCreateReason',
                shortName: 'Create Benefit Plan'
            }
        }, "benefitPlan.chosenBenefitPlanRiders");
    }

    const amendPayload = jsonData

    const submitHandler = async (body) => {

        try {
            setErrorMessage(null)
            setLoading(true)
            const desireOrder = ['asOfDate', 'maintenanceInfo', 'maintenanceReasonCode', 'maintenanceComment', 'benefitPlan']
            const bodyString = customStringify(body, desireOrder)
            const result = await submitJobBenefitPlan({ bodyString })

            let jobStatusRes

            do {
                await delay(3000)
                jobStatusRes = await fetchGetApiRequestJobStatus(result) // pass job pk and sk as params to get job status
            } while (jobStatusRes.requestStatus === 'PENDING');


            const responseBody = jobStatusRes.responseBody

            if (responseBody.status === 'ERROR' || responseBody.status === 'FAILURE') {
                toast.error('Something went wrong!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
                //  const messageDescription = result[0].transactionInformation.exceptions.map(exp => `${exp.policyName} ${exp.messageDescription}`).join()
                throw new Error(responseBody?.errors?.error?.message || responseBody.status, { cause: responseBody })
            }

            toast.success('Success!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            await submitBenefitPlanAudit({
                body: {
                    action: body.maintenanceInfo?.transactionType,
                    benefitPlanHccId: body.benefitPlan.benefitPlanHccId,
                    requestBody: bodyString,
                    responseBody
                }
            });

            if (body.maintenanceInfo.transactionType === ACTIONS.AMEND) {
                navigate('/config/plans', { state: { benefitPlanName: body.benefitPlan.benefitPlanName } })
            } else {
                await refetch()
            }


        } catch (err) {
            console.log(err)
            setIsModalOpen({ message: err.cause || err.message })
        } finally {
            setLoading(false)
        }

    }

    return (<>

        <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
        >
            <div style={{ padding: '1rem', width: '100%', overflowY: 'scroll', height: '100%' }}>

                <ReactJson
                    style={{ padding: '1rem' }}
                    src={isModalOpen || {}}
                    name={false}
                    collapsed={3}
                    collapseStringsAfterLength={150}
                    displayDataTypes={false}
                    displayObjectSize={false}
                    sortKeys={true}
                />
            </div>


        </Modal>

        <div className={'container scrollable'}>
            <p className='title'>Benefit plan Migration.</p>
            <p className="sub-title">Copy and paste benefit plans between different environments.</p>

            <br />

            {!jsonData && <div className="form-input">
                <label>Benefit plan</label>
                <textarea
                    value={jsonString}
                    onChange={(e) => setJsonString(e.target.value)}
                    placeholder="Enter request payload ..."
                    rows="10"
                    cols="50"
                /></div>}

            {jsonData ? <>
                <p className="clickable-link" onClick={() => setViewDiff(!viewDiff)} style={{
                    padding: '0rem 0rem 1rem 0rem'
                }}> {viewDiff ? 'Show payload' : 'Show Diff'}</p>
                {viewDiff && exisitngBenefitPlan && amendPayload && <ReactDiffViewer
                    oldValue={JSON.stringify(exisitngBenefitPlan, null, 4)}
                    newValue={JSON.stringify(amendPayload?.benefitPlan, null, 4)}
                    disableWordDiff={true}
                    splitView={true}
                // renderContent={highlightSyntax}
                />}

                {exisitngBenefitPlan ?
                    <PanelGroup autoSaveId="review" direction="horizontal" style={{}}>
                        <Panel defaultSize={50} style={{ overflow: 'scroll' }} >
                            <p style={{ fontWeight: 600 }}>Existing plan</p>
                            <ReactJson
                                style={{ padding: "1rem" }}
                                src={exisitngBenefitPlan}
                                name={false}
                                collapsed={false}
                                collapseStringsAfterLength={150}
                                displayDataTypes={false}
                                displayObjectSize={false}
                                enableClipboard={false}
                                sortKeys={false}
                            />
                        </Panel>

                        <PanelResizeHandle className="resize-handle" >
                            <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', height: '100%' }}>
                                {/* sadfsfasd */}
                                <MdDragIndicator size={'1.2rem'} />
                            </div>

                        </PanelResizeHandle>

                        <Panel defaultSize={50} style={{ overflow: 'scroll' }} >
                            <p style={{ fontWeight: 600 }}>Amend Payload</p>
                            <ReactJson
                                style={{ padding: "1rem" }}
                                src={amendPayload}
                                name={false}
                                collapsed={false}
                                collapseStringsAfterLength={150}
                                displayDataTypes={false}
                                displayObjectSize={false}
                                enableClipboard={false}
                                sortKeys={false}
                            />
                            {!(loading || isFetching) && <button className="btn" style={{ maxWidth: '100px' }} onClick={() => submitHandler(amendPayload)}>Amend</button>}

                        </Panel>
                    </PanelGroup> : <>
                        <p style={{ fontWeight: 600 }}>Create Payload</p>
                        <ReactJson
                            style={{ padding: "1rem" }}
                            src={createPayload}
                            name={false}
                            collapsed={false}
                            collapseStringsAfterLength={150}
                            displayDataTypes={false}
                            displayObjectSize={false}
                            enableClipboard={false}
                            sortKeys={false}
                        />
                        {!(loading || isFetching) && <button className="btn" style={{ maxWidth: '100px' }} onClick={() => submitHandler(createPayload)}>Create</button>}


                        {/* <ReactJson
                        style={{ padding: "1rem" }}
                        src={amendPayload}
                        name={false}
                        collapsed={false}
                        collapseStringsAfterLength={150}
                        displayDataTypes={false}
                        displayObjectSize={false}
                        sortKeys={false}
                    />
                    <button style={{ maxWidth: '100px' }}>Amend</button> */}


                    </>}

            </> : <></>}

            {(loading || isFetching) && <div className="loader" />}
            {errorMessage && <p className="danger" style={{ padding: '0rem 0rem 2rem 0rem' }}>{errorMessage}</p>}
            {error && <p className="danger" style={{ padding: '0rem 0rem 2rem 0rem' }}>{error?.message}</p>}

        </div>
    </>

    )
}

export default MigrateBenefitPlan